import type { FlowItem } from "../Types/BookShipmentFlowItemType";

export function bookShipmentIsInFlow(
  flow: Array<FlowItem>,
  identifier: string,
) {
  const item = flow.find(function (item) {
    return item.identifier === identifier;
  });

  return item !== undefined;
}
